import { client } from '../client';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const deleteUserAvailability = async (
  user_id: string,
  availability_id: string,
  userRole?: string,
): Promise<void> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.delete(`${prefix}/users/${user_id}/user_availability/${availability_id}`);

  return data;
};
